// Module
var code = "<script id=\"wcc-components-grid-new-column\" type=\"text/template\">\r\n    <div class=\"grid-new__column__body\" data-bind=\"dom: bodyNode, hideTemplate: true\"></div>\r\n</script>";
// Exports
module.exports = code;